/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBusinessRuleTestResponseFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type BusinessRuleTestResponse, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { CreateFromCsvRequestBuilderRequestsMetadata, type CreateFromCsvRequestBuilder } from './createFromCsv/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/VerifyBusinessRule
 */
export interface VerifyBusinessRuleRequestBuilder extends BaseRequestBuilder<VerifyBusinessRuleRequestBuilder> {
    /**
     * The CreateFromCsv property
     */
    get createFromCsv(): CreateFromCsvRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BusinessRuleTestResponse>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<VerifyBusinessRuleRequestBuilderPostQueryParameters> | undefined) : Promise<BusinessRuleTestResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<VerifyBusinessRuleRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface VerifyBusinessRuleRequestBuilderPostQueryParameters {
    id?: number;
    newSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const VerifyBusinessRuleRequestBuilderUriTemplate = "{+baseurl}/Allotment/VerifyBusinessRule?id={id}&newSize={newSize}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VerifyBusinessRuleRequestBuilderNavigationMetadata: Record<Exclude<keyof VerifyBusinessRuleRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createFromCsv: {
        requestsMetadata: CreateFromCsvRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const VerifyBusinessRuleRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: VerifyBusinessRuleRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBusinessRuleTestResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
